import { defineStore } from 'pinia';
import {apiService} from "@/services/apiService";
import {ALERT_INFO_CLASSNAME, DEFAULT_CHAT_MODEL} from "@/constants";
import {useAppStateStore} from "@/modules/chat/stores/appStore";
import {useChatStore} from "@/modules/chat/stores/chatStore";
import {formAlert} from "@/services/alert";
import {isImageGeneration, isLkChat, isPublicMode} from "@/services/router";

export const useReferenceStore = defineStore('reference', {
    state: () => ({
        presets: [],
        presetGroups: [],
        models: [],
        uml_modes: [],
        examples: {
            images: [],
            uml: [],
        },
        assistants: [],
        assistants_icons: [],
        quick_assistants: [],
        assistants_limit: 1,
        default_text_model: DEFAULT_CHAT_MODEL,
        map_url_to_model: {},
    }),

    getters: {},

    actions: {
        async fetchPresets() {
            try {
                const {presets, groups} = await apiService.getPresets();
                const result = [];
                for (const group of groups) {
                    const groupPresets = presets.filter(preset => preset.type === group.value);
                    if (groupPresets.length === 0) {
                        continue;
                    }
                    result.push({
                        title: group.label,
                        alias: group.value,
                        presets: groupPresets,
                    });
                }
                this.presets = presets;
                this.presetGroups = result;
            } catch (error) {
                console.error('Error fetching presets:', error);
            }
        },
        async fetchModels() {
            try {
                const {data: models} = await apiService.getModels();
                return models;
            } catch (error) {
                console.error('Error fetching models:', error);
            }
        },
        async fetchUmlModes() {
            try {
                const {data: modes} = await apiService.getUmlModes();
                return modes;
            } catch (error) {
                console.error('Error fetching um modes:', error);
            }
        },
        async fetchExamples() {
            try {
                return await apiService.getExamples();
            } catch (error) {
                console.error('Error fetching um modes:', error);
            }
        },
        async initExamples() {
            const {images, uml} = await this.fetchExamples();
            this.examples.images = images;
            this.examples.uml = uml;
        },
        async initSettings() {
            const {
                default_text_model: defaultTextModel,
                map_url_to_model: mapUrlToModel,
                attach_vector_database: attachVectorDatabase,
                assistants,
                quick_assistants: quickAssistants,
                authorized,
                assistants_limit: assistantsLimit,
                assistants_icons: assistantsIcons,
                error
            } = await apiService.getChatWidgetSettings();
            this.default_text_model = defaultTextModel;
            this.map_url_to_model = mapUrlToModel;

            const chatStore = useChatStore();

            const appStateStore = useAppStateStore();
            const referenceStore = useReferenceStore();

            if (error) {
                const errorMessage = await formAlert(error.message, ALERT_INFO_CLASSNAME);
                chatStore.setError(errorMessage);
                appStateStore.setDisableAll(error.details?.disableAll);
            }
            appStateStore.setAttachVectorDatabase(attachVectorDatabase);
            appStateStore.authorized = authorized;

            if (isLkChat() || isPublicMode() && !isImageGeneration()) {
                referenceStore.assistants = assistants;

                referenceStore.assistants = assistants;
                referenceStore.quick_assistants = quickAssistants;
                referenceStore.assistants_limit = assistantsLimit;
                referenceStore.assistants_icons = assistantsIcons;

                appStateStore.features.manageAssistants = authorized;
            }
        },
        async initUmlModes() {
            this.uml_modes = await this.fetchUmlModes();
        }
    },
});